export type NavAsideInfo = [string, string, string, React.ElementType, any?];

const navClass =
  "group hover:bg-sidebar-menu-active h-10 sm:h-20 px-2 w-full flex justify-center border-b border-b-sidebar-menu-border hover:border-b-sidebar-menu-active";
// avoid deleting by optimizing unused w-5/h-4 styles
const dummy = <div className="w-5 h-5 w-4 h-4" />; // eslint-disable-line
const NavItem = ({ name, title, Icon, active, onClick, size = 5 }) => (
  <li
    className={navClass + (active ? " bg-sidebar-menu-active border-b-sidebar-menu-active" : "")}
    onClick={onClick}
    data-name={name}
  >
    <button className="flex flex-col items-center justify-start pt-1 sm:pt-3">
      <div className="bg-sidebar-menu-icon group-hover:bg-sidebar-menu-focus rounded-xl w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center text-lg">
        <Icon className={`w-${size} h-${size} text-sidebar-menu-active`} />
      </div>
      <span
        className={`hidden sm:inline group-hover:text-sidebar-menu-focus text-center leading-none my-auto ${
          active ? "text-sidebar-menu-active-text" : ""
        }`}
      >
        {title}
      </span>
    </button>
  </li>
);

export const NavAside = ({ sectionInfo, active, onClick }) => (
  <div className="fixed left-0 pt-14 bg-sidebar-menu border-r border-r-sidebar-menu-border h-screen z-20">
    <ul className="font-roboto tracking-tight text-sidebar-menu-text w-10 sm:w-20 text-[11px]">
      {sectionInfo.map(([name, _title, short, Icon, options]) => (
        <NavItem
          key={name}
          name={name}
          title={short}
          Icon={Icon}
          size={options?.size || 5}
          active={active === name}
          onClick={onClick}
        />
      ))}
    </ul>
  </div>
);
